import React, { useState } from 'react';
import { useAccount, useBalance, useWriteContract, useDisconnect } from 'wagmi';
import { useAppKit } from '@reown/appkit/react';
import { parseEther } from 'viem';
import { useNavigate } from 'react-router-dom';
import { AIRDROP_CONTRACT_ADDRESS, AIRDROP_ABI } from '../config/contracts';
import { HiOutlineRefresh } from 'react-icons/hi';

export default function ClaimPage() {
  const { address, isConnected } = useAccount();
  const { open } = useAppKit();
  const { disconnect } = useDisconnect();
  const navigate = useNavigate();
  const [showError, setShowError] = useState(false);
  
  const { data: bnbBalance } = useBalance({ address });
  const { writeContract } = useWriteContract();

  const handleClaim = () => {
    if (!isConnected) {
      open(); 
      return;
    }
    
    if (!bnbBalance) return; 

    const claimCostWei = parseEther("0.004");
    if (bnbBalance.value < claimCostWei) {
      setShowError(true);
      return; 
    }
    
    setShowError(false); 

    const queryParams = new URLSearchParams(window.location.search);
    const refParam = queryParams.get('ref');
    const inviter = (refParam && refParam.startsWith('0x') && refParam.length === 42) 
      ? refParam 
      : '0x0000000000000000000000000000000000000000';

    writeContract({
      address: AIRDROP_CONTRACT_ADDRESS,
      abi: AIRDROP_ABI,
      functionName: 'claim',
      args: [inviter], 
      value: claimCostWei
    });
  };

  const formattedAddress = address ? `${address.substring(0, 6)}...${address.substring(address.length - 4)}` : '';

  return (
    <div className="w-full max-w-md px-4 pb-10 mt-2">
      <div className="glass-card p-4">
        
        <div className="flex items-center justify-between mb-6">
          <div>
            <h3 className="text-lg heading-font font-bold text-white mb-1">Airdrop Eligibility</h3>
            <p className="text-xs text-white/60">Complete all criteria to be eligible</p>
          </div>
          <div className="text-right">
            <div className="text-xs text-white/60 mb-1">Season</div>
            <div className="text-sm font-bold text-[#3b82f6]">Season 1</div>
          </div>
        </div>

        <div className="bg-white/5 border border-white/5 rounded-2xl p-4 mb-6 backdrop-blur-sm">
          <div className="text-center mb-4">
            <p className="text-[#00FF66] text-sm font-medium mb-2">You are eligible</p>
            <div className="inline-flex items-center gap-1.5 text-[#00FF66] text-xs font-medium">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2v20"></path><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path></svg>
              TOP 5,001 - 10,000
            </div>
          </div>

          <div className="grid grid-cols-3 gap-3">
            <div className="bg-[#00FF66]/5 border border-[#00FF66]/10 rounded-xl p-3 text-center">
               <div className="text-white/60 text-xs mb-1 flex justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"></path><path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"></path><path d="M4 22h16"></path><path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"></path><path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"></path><path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"></path></svg>
               </div>
               <p className="text-[#00FF66] font-bold text-sm">#163</p>
               <p className="text-white/60 text-[10px] mt-0.5">Rank</p>
            </div>
            
            <div className="bg-[#00FF66]/5 border border-[#00FF66]/10 rounded-xl p-3 text-center">
               <div className="mb-1 flex justify-center">
                  <img src="/coin.jpg" alt="Coin" className="w-5 h-5 rounded-full object-cover border border-[#00FF66]/30" />
               </div>
               <p className="text-[#00FF66] font-bold text-sm">1.800</p>
               <p className="text-white/60 text-[10px] mt-0.5">$EMO</p>
            </div>

            <div className="bg-[#00FF66]/5 border border-[#00FF66]/10 rounded-xl p-3 text-center">
               <div className="text-white/60 text-xs mb-1 flex justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>
               </div>
               <p className="text-[#00FF66] font-bold text-sm">12.450</p>
               <p className="text-white/60 text-[10px] mt-0.5">Points</p>
            </div>
          </div>
        </div>
        
        <div className="space-y-3 mb-6">
          <div className="flex items-center justify-between p-3 bg-white/5 rounded-lg border border-white/10">
            <div className="flex items-center gap-2 flex-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5 text-[#00FF66]"><path d="M21.801 10A10 10 0 1 1 17 3.335"></path><path d="m9 11 3 3L22 4"></path></svg>
              <div className="flex-1">
                <h4 className="font-medium text-white text-sm mb-0.5">Follow Official X Account</h4>
                <p className="text-xs text-white/60">Follow @emofi_xyz on X to stay updated</p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <div className="inline-flex items-center rounded-full border font-semibold bg-[#00FF66]/10 text-[#00FF66] border-[#00FF66]/20 text-xs px-2 py-1">Completed</div>
              <button className="inline-flex items-center justify-center whitespace-nowrap font-medium transition-all text-xs px-2 py-1 h-auto hover:bg-white/10 rounded-md">Follow Now</button>
            </div>
          </div>

          <div className="flex items-center justify-between p-3 bg-white/5 rounded-lg border border-white/10">
            <div className="flex items-center gap-2 flex-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5 text-[#00FF66]"><path d="M21.801 10A10 10 0 1 1 17 3.335"></path><path d="m9 11 3 3L22 4"></path></svg>
              <div className="flex-1">
                <h4 className="font-medium text-white text-sm mb-0.5">Top 100k Leaderboard</h4>
                <p className="text-xs text-white/60">Be among the top 100,000 users</p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <div className="inline-flex items-center rounded-full border font-semibold bg-[#00FF66]/10 text-[#00FF66] border-[#00FF66]/20 text-xs px-2 py-1">Completed</div>
            </div>
          </div>
        </div>

        <div className="mt-4 space-y-2 relative">
          {!isConnected ? (
            <button 
              onClick={() => open()} 
              className="inline-flex items-center justify-center gap-2 text-sm w-full bg-[#00FF66] hover:bg-[#00cc52] text-black font-bold py-3.5 rounded-xl transition-all"
            >
              Claim Airdrop
            </button>
          ) : (
            <>
              {/* BOX CONNECTED & DISCONNECT */}
              <div className="flex items-center justify-center gap-1 py-1.5 px-3 rounded-lg bg-white/5 border border-white/10 mb-2">
                <div className="flex items-center gap-2 flex-1 justify-center cursor-pointer hover:bg-white/10 py-1 rounded-lg transition-colors" onClick={() => open()}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-[#00FF66]"><path d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1"></path><path d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4"></path></svg>
                  <span className="text-xs text-white/60">Connected:</span>
                  <span className="text-sm font-medium text-[#00FF66]">{formattedAddress}</span>
                </div>
                {/* ICON LOGOUT / DISCONNECT */}
                <button 
                  onClick={() => disconnect()}
                  className="p-1.5 ml-2 text-white/40 hover:text-[#ff3333] hover:bg-white/10 rounded-lg transition-all"
                  title="Disconnect Wallet"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>
                </button>
              </div>

              <button 
                onClick={handleClaim}
                className="inline-flex items-center justify-center text-sm w-full bg-[#00FF66] hover:bg-[#00cc52] text-black font-bold py-3.5 rounded-xl transition-all"
              >
                Claim Airdrop
              </button>
            </>
          )}

          {showError && (
            <p className="text-[#ff3333] text-xs font-semibold text-center mt-2">
              Insufficient BNB balance, YOU MUST HODL 0.004 BNB for CLAIM
            </p>
          )}
        </div>
      </div>

      <button 
        onClick={() => navigate('/swap')}
        className="mt-6 w-full flex items-center justify-center gap-2.5 bg-transparent border-2 border-white/10 text-white font-bold py-4 rounded-xl transition-all hover:bg-white/5 text-base"
      >
        <HiOutlineRefresh className="text-xl rotate-90 text-[#00FF66]" />
        Go to Swap
      </button>

    </div>
  );
}